<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.main.isApplicable"
    [attr.id]="data.main.title"
  >
    <mat-slide-toggle
      [color]="data.main.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.main.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="data.main.isApplicable && !data.main.isPassed"
        >{{ data.main.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.main.isApplicable && !data.main.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.main.title }}
    </span>
    <div class="cases" *ngIf="data.main.isApplicable; else notApplicable">
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.hubLocation"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.hubMadeFrom"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.hubModel"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.detectionSystemTestedBy"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.protectedAreas"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.siteRiskLevel"
      ></authority-labs-check-value-case>
    </div>
  </section>

  <div *ngIf="printPreview">
    <mat-card
      class="mat-elevation-z4"
      *ngFor="let area of data.areas; let ind = index"
    >
      <mat-card-header>
        <mat-card-title>{{ tabName(ind) }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container
          *ngTemplateOutlet="formTpl; context: { area: area, ind: ind }"
        ></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-tab-group
    class="mat-elevation-z4"
    [(selectedIndex)]="selectedTab"
    *ngIf="!printPreview"
  >
    <mat-tab *ngFor="let area of data.areas; let ind = index">
      <ng-template mat-tab-label>
        <mat-icon
          class="fail"
          color="warn"
          *ngIf="!area.gasExtinguishingSystem.isPassed"
        >
          priority_high
        </mat-icon>
        <span>{{ tabName(ind) }}</span>
      </ng-template>
      <ng-template matTabContent>
        <div [style.margin-right]="readonly || printPreview ? '45px' : '0'">
          <ng-container
            *ngTemplateOutlet="formTpl; context: { area: area, ind: ind }"
          ></ng-container>
          <section *ngIf="!(readonly || printPreview)">
            <button
              class="btn remove-btn"
              mat-raised-button
              aria-label="remove"
              [disabled]="data.areas.length === 1"
              (click)="removeTest()"
            >
              <span>הסר</span>
            </button>
            <button
              class="btn add-btn"
              mat-raised-button
              color="accent"
              aria-label="duplicate"
              (click)="duplicateTest()"
            >
              <span>שכפל בדיקה נוכחית</span>
            </button>
            <button
              class="btn add-btn"
              mat-raised-button
              color="accent"
              aria-label="add"
              (click)="addTest()"
            >
              <span>הוסף בדיקה</span>
            </button>
          </section>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</main>

<ng-template #notApplicable>
  <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
    <mat-radio-button checked="false">מתאים</mat-radio-button>
    <mat-radio-button checked="false">לא מתאים</mat-radio-button>
    <mat-radio-button value="true" checked="true">לא ישים</mat-radio-button>
  </mat-radio-group>
</ng-template>

<ng-template #formTpl let-area="area" let-ind="ind">
  <section
    class="check-cases"
    [class.border]="area.gasExtinguishingSystem.isApplicable"
    [attr.id]="area.gasExtinguishingSystem.title"
  >
    <mat-slide-toggle
      [color]="area.gasExtinguishingSystem.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.gasExtinguishingSystem.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.gasExtinguishingSystem.isApplicable &&
          !area.gasExtinguishingSystem.isPassed
        "
        >{{ area.gasExtinguishingSystem.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.gasExtinguishingSystem.isApplicable &&
        !area.gasExtinguishingSystem.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.gasExtinguishingSystem.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.gasExtinguishingSystem.isApplicable; else notApplicable"
    >
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.basedOnPrEngineerSystem"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.computerRun"
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.tankMadeOf"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.containerModel"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.gasWeight"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.pipeDesignType"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.modelDispersionNozzledDesign"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.dispersalNostrilsCount"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.boardDetailsOrProtectedSpace"
      ></authority-labs-check-value-case>

      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          area.gasExtinguishingSystem.electricalPowerUnitMatchDiscoveryHub
        "
      ></authority-labs-check-case>
      <authority-labs-check-basic-select-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.siteRiskLevel"
        [options]="['Class A', 'Class B', 'Class C']"
      ></authority-labs-check-basic-select-case>
      <authority-labs-check-basic-select-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.classificationType"
        [options]="['חומרים דליקים - A', 'נוזלים - B', 'חשמל - C']"
      ></authority-labs-check-basic-select-case>
      <authority-labs-check-dimensions-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasExtinguishingSystem.boardDimensions"
      ></authority-labs-check-dimensions-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="area.gasIndoorTest.isApplicable"
    [attr.id]="area.gasIndoorTest.title"
  >
    <mat-slide-toggle
      [color]="area.gasIndoorTest.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.gasIndoorTest.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.gasIndoorTest.isApplicable && !area.gasIndoorTest.isPassed
        "
        >{{ area.gasIndoorTest.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.gasIndoorTest.isApplicable && !area.gasIndoorTest.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.gasIndoorTest.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.gasIndoorTest.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.shutdownTriggeredByOneDetector"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.crossChecked"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.beforeShutdownDelay"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.shutdownLampExist"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.evacuationHornExist"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.evacuationHornWorksAsExpected"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.ventilationSystemWorksAsExpected"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.yellowShutdownButtonInstalled"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasIndoorTest.extinguishingSpaceIncludesDoors"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          area.gasIndoorTest.engSystemInstallationAccordingToPcOutput
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          area.gasIndoorTest.fireAndPlumbingTanksSetAccordingToRequirements
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          area.gasIndoorTest.nostrilsDistanceAccordingToRequirements
        "
      ></authority-labs-check-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="area.gasActivationTest.isApplicable"
    [attr.id]="area.gasActivationTest.title"
  >
    <mat-slide-toggle
      [color]="area.gasActivationTest.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="area.gasActivationTest.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          area.gasActivationTest.isApplicable &&
          !area.gasActivationTest.isPassed
        "
        >{{ area.gasActivationTest.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        area.gasActivationTest.isApplicable && !area.gasActivationTest.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ area.gasActivationTest.title }}
    </span>
    <div
      class="cases"
      *ngIf="area.gasActivationTest.isApplicable; else notApplicable"
    >
      <authority-labs-check-basic-select-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.containerPosition"
        [options]="['תלוי', 'עומד', 'שוכב']"
      ></authority-labs-check-basic-select-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.containerIsAccessible"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.containerLocation"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.solonoidModel"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.gasTypeAndWeight"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.pipingDiameterAndType"
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.detectorDetails"
        label="כתובת הגלאי"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.crosstab"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.shutdownButton"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.sealing"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          area.gasIndoorTest.fireAndPlumbingTanksSetAccordingToRequirements
        "
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.powerOutages"
        label="כתובת הניתוק"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.pressureClockIndicatesGreen"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="area.gasActivationTest.soloenoidConnected"
      ></authority-labs-check-case>
    </div>
  </section>
</ng-template>
